var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5026 15.4167C1.5026 16.425 2.3276 17.25 3.33594 17.25H10.6693C11.6776 17.25 12.5026 16.425 12.5026 15.4167V6.25C12.5026 5.24167 11.6776 4.41667 10.6693 4.41667H3.33594C2.3276 4.41667 1.5026 5.24167 1.5026 6.25V15.4167ZM4.2526 6.25H9.7526C10.2568 6.25 10.6693 6.6625 10.6693 7.16667V14.5C10.6693 15.0042 10.2568 15.4167 9.7526 15.4167H4.2526C3.74844 15.4167 3.33594 15.0042 3.33594 14.5V7.16667C3.33594 6.6625 3.74844 6.25 4.2526 6.25ZM10.2109 1.66667L9.5601 1.01583C9.3951 0.850833 9.15677 0.75 8.91844 0.75H5.08677C4.84844 0.75 4.6101 0.850833 4.4451 1.01583L3.79427 1.66667H1.5026C0.998437 1.66667 0.585938 2.07917 0.585938 2.58333C0.585938 3.0875 0.998437 3.5 1.5026 3.5H12.5026C13.0068 3.5 13.4193 3.0875 13.4193 2.58333C13.4193 2.07917 13.0068 1.66667 12.5026 1.66667H10.2109Z",
    fill: "#636363"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteOutline);
export default __webpack_public_path__ + "static/media/delete-outline.30677bce69a253402e859f633f891fe1.svg";
export { ForwardRef as ReactComponent };